<template>
  <b-modal
    id="ModalFullGallery"
    hide-header
    hide-footer
    modal-class="success-submit-modal"
    ignore-enforce-focus-selector=".webim-root"
    @hidden="hideModal"
  >
    <div class="modal__wrapper modal-full-gallery__wrapper">
      <div class="map-card__close" @click="hideModal"></div>

      <div class="modal-full-gallery__gallery-wrap">
        <SlickGallery
          class="slick-gallery_full-window"
          :odp="odp"
          :enable-modal-full="false"
          :initial-slide="currentSlide"
        />
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalFullGallery',
  components: {
    SlickGallery: () => import('./SlickGallery.vue')
  },
  props: {
    odp: Object,
    currentSlide: {
      type: Number,
      default: 0,
    },
  },
  mounted() {
    this.$bvModal.show('ModalFullGallery');
  },
  methods: {
    hideModal() {
      this.$bvModal.hide('ModalFullGallery');
      this.$emit('close');
    },
  },
};
</script>
<style lang="scss">
  @import './ModalFullGallery.scss';
</style>
